import Link from "next/link";
import SummerEyesButton from "../branding/SummerEyesButton";

export default function BottomCTA(props) {
  return (
    <>
      <div className="container mx-auto mt-48">
        <div className="justify-left relative z-10 -mt-64 flex flex-wrap rounded-2xl border border-slate-300 bg-summer-base py-16 px-12 shadow-xl backdrop-blur-sm">
          <div className="w-full text-left lg:w-8/12">
            <h3 className="text-3xl font-medium text-gray-100">
              Sounds good? Let's get you onboard.
            </h3>
            <p className="mt-4 mb-4 text-lg leading-relaxed text-gray-300">
              Sign up today and receive access to our Free subscription as an
              early adopter, with direct access to the founding team & special
              discounts for upcoming releases.
            </p>
            <div className="mt-4">
              <SummerEyesButton customTailwind="my-4 px-10" href="/login" left>
                Register <span className="italic">- for free</span>
              </SummerEyesButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
